import { EuiIcon } from '@elastic/eui';
import { sntConfig } from 'app/models/install-verification-tags/device-config/slap-and-track-config';

export const installItemsInfo = [
  {
    title: 'Battery',
    description: (
      <>
        <div>
          <EuiIcon
            type="faceHappy"
            color="success"
          />
          <span> Battery voltage is greater than 6.0</span>
        </div>
        <div>
          <EuiIcon
            type="faceNeutral"
            color="warning"
          />
          <span> Battery voltage is between 4.5 and 6.0</span>
        </div>
        <div>
          <EuiIcon
            type="faceSad"
            color="danger"
          />
          <span> Battery voltage is less than 4.5 or non-existent</span>
        </div>
      </>
    ),
  },
  {
    title: 'Location',
    description: (
      <>
        <div>
          <EuiIcon
            type="faceHappy"
            color="success"
          />
          <span> Valid latitude/longitude</span>
        </div>
        <div>
          <EuiIcon
            type="faceNeutral"
            color="warning"
          />
          <span>
            {' '}
            Invalid latitude and longitude. Coordinates must fall within one of the configured
            regions:
            {sntConfig.health.location.validRegions
              .map(
                region =>
                  ` ${region.name} (${region.MIN_LATITUDE} and ${region.MAX_LATITUDE}, ${region.MIN_LONGITUDE} and ${region.MAX_LONGITUDE})`
              )
              .join(', ')}
          </span>
        </div>
        <div>
          <EuiIcon
            type="faceSad"
            color="danger"
          />
          <span>
            {' '}
            No Location found. If the tracker has no cell signal it will not have gps coordinates
          </span>
        </div>
      </>
    ),
  },
  {
    title: 'Firmware',
    description: (
      <>
        <div>
          <EuiIcon
            type="faceHappy"
            color="success"
          />
          <span> Firmware is present</span>
        </div>
        <div>
          <EuiIcon
            type="faceSad"
            color="danger"
          />
          <span> No firmware found</span>
        </div>
      </>
    ),
  },
  {
    title: 'Communication',
    description: (
      <>
        <div>
          <EuiIcon
            type="faceHappy"
            color="success"
          />
          <span> Tracker has sent messages within the last 48 hours</span>
        </div>
        <div>
          <EuiIcon
            type="faceSad"
            color="danger"
          />
          <span> Tracker has not sent messages in over 48 hours or no communication detected</span>
        </div>
      </>
    ),
  },
];
